export default "/images/product-2.png?c1a3ff567292b86cf44243e805db8956";